import {
  makeStyles,
  TextField as MuiTextField,
  TextFieldProps,
} from "@material-ui/core";
import React, { useMemo } from "react";

let uniqueId = 0;

export type TextProps = TextFieldProps & {
  readOnly?: boolean;
};

const useStyles = makeStyles((theme) => ({
  readOnlyInput: {},
}));

export const TextField = React.forwardRef<unknown, TextProps>(
  (
    {
      value,
      onChange,
      id,
      variant,
      fullWidth = true,
      type,

      InputProps,
      ...props
    },
    ref
  ) => {
    const classes = useStyles();
    const safeValue = value === null || value === undefined ? "" : value;
    const readOnly = InputProps?.readOnly || props.readOnly;
    const knownId = useMemo(() => id || `textField_${++uniqueId}`, [id]);
    const localOnChange: typeof onChange = (event) => {
      if (onChange) {
        const value =
          event.target.value === ""
            ? null
            : type === "number"
            ? Number(event.target.value)
            : event.target.value;

        onChange(({
          ...event,
          target: {
            ...event.target,
            value,
          },
        } as unknown) as React.ChangeEvent<HTMLInputElement>);
      }
    };
    const inputClassName = readOnly ? classes.readOnlyInput : undefined;
    const inputProps =
      readOnly === undefined
        ? InputProps
        : {
            ...InputProps,
            readOnly,
            className: inputClassName,
          };

    const label =
      readOnly === undefined || readOnly === false
        ? props.label
        : `${props.label} (Read Only)`;

    return (
      <MuiTextField
        variant={variant || "outlined"}
        fullWidth={fullWidth}
        onChange={localOnChange}
        value={safeValue}
        id={knownId}
        type={type}
        InputProps={inputProps}
        {...props}
        label={label}
      />
    );
  }
);
